<template>
  <div>
    <AbrFormSectionWrapper
      :def="def"
      :model="model"
      :modal="modal"
    ></AbrFormSectionWrapper>
    <!-- <AppPortal>
      <AbrFormSectionWrapper
        :def="def"
        :model="model"
        :modal="modal"
      ></AbrFormSectionWrapper>
    </AppPortal> -->
  </div>
</template>

<script>
// import AbrFormPanel from "@/components/form/AbrFormPanel";
// import AppCard from "@/components/library/container/AppCard";
// import AppPortal from "@/components/library/portal/AppPortal"
import AbrFormSectionWrapper from "@/components/form/AbrFormSectionWrapper"
// import AppPortalTarget from "@/components/library/portal/AppPortalTarget"

export default {
  name: "AbrFormSection",
  components: {
    // AppCard,
    // "abr-form-panel": AbrFormPanel,
    // AppPortalTarget,
    // AppPortal,
    AbrFormSectionWrapper
  },
  props: ["def", "model","modal"],
};
</script>

